
import { Facet } from '../models/Facet';
import { LayoutTypeFacet } from '../models/layouts/LayoutTypeFacet';

export const currentItemFacet = new Facet<{ itemKey: string; }>('currentItem');

export const currentSelectionFacet = new Facet<{ selectionKey: string; }>('currentSelection');

export const selectedItemsFacet = new Facet<{ itemKeys: string[]; }>('selectedItems');

export const availableLayoutsFacet = new Facet<{ [layoutId: string]: boolean; }>('availableLayouts');

export const layoutTypeFacet = new Facet<LayoutTypeFacet>('layoutType');

export const defaultLayoutFacet = new Facet<LayoutTypeFacet>('defaultLayoutType');

export const preferredLayoutFacet = new Facet<{
  layoutHandlerKey: string;
}>('preferredLayout');

export const hasLayoutFacet = new Facet<boolean>('hasLayout');

export const groupsCollapsedFacet = new Facet<{ [key: string]: boolean }>('groupsCollapsed');

export const allGroupsCollapsedFacet = new Facet<boolean>('allGroupsCollapsed');

export const startItemIndexInViewFacet = new Facet<{ [key: string]: number }>('startItemIndexInView');
